import type { VehicleSpec } from './types';

/** Mercedes Sprinter-style high-roof trotro (the big one). */
export const SPRINTER: VehicleSpec = {
  id: 'sprinter',
  length: 5.9,
  width: 2.0,
  height: 2.75,
  profile: [[0, 0.38], [0, 2.66], [0.12, 2.75], [4.5, 2.75], [4.72, 2.58], [5.2, 1.42], [5.72, 1.18], [5.9, 0.92], [5.9, 0.38]],
  windscreen: 4,
  windows: [
    { u0: 0.35, u1: 1.3, v0: 1.55, v1: 2.35 },
    { u0: 1.4, u1: 2.35, v0: 1.55, v1: 2.35 },
    { u0: 2.45, u1: 3.4, v0: 1.55, v1: 2.35 },
    { u0: 3.5, u1: 4.45, v0: 1.55, v1: 2.35 },
    { u0: 4.55, u1: 5.02, v0: 1.5, v1: 2.3 },
  ],
  door: { u0: 2.4, u1: 3.45, v0: 0.45, v1: 2.4 },
  rearWindow: [1.5, 2.4],
  wheels: { rear: 1.2, front: 4.95, radius: 0.36 },
  roofRack: true,
};

/**
 * Toyota HiAce semi-bonnet, the "Fish": long sloping nose, raked windscreen, low flat roof,
 * big tinted windows, white steel wheels. Modelled from the owner's reference photo.
 */
export const HIACE_FISH: VehicleSpec = {
  id: 'hiace',
  length: 5.2,
  width: 1.82,
  height: 2.0,
  profile: [[0, 0.34], [0, 1.9], [0.08, 2.0], [3.5, 2.0], [3.72, 1.9], [4.45, 1.12], [5.02, 0.97], [5.2, 0.8], [5.2, 0.34]],
  windscreen: 4,
  windows: [
    { u0: 0.18, u1: 1.42, v0: 1.18, v1: 1.86 },
    { u0: 1.55, u1: 2.78, v0: 1.18, v1: 1.86 },
    { u0: 2.95, u1: 3.62, v0: 1.16, v1: 1.84 },
  ],
  door: { u0: 1.5, u1: 2.86, v0: 0.4, v1: 1.92 },
  rearWindow: [1.18, 1.86],
  wheels: { rear: 0.95, front: 4.3, radius: 0.31 },
  rimColor: '#f2f2f2',
  roofRack: false,
};

/** Toyota Vitz: the small 4-seat saloon. Short nose, tall round cabin, sloping hatch. */
export const VITZ: VehicleSpec = {
  id: 'vitz',
  length: 3.9,
  width: 1.66,
  height: 1.5,
  profile: [[0, 0.34], [0, 1.08], [0.14, 1.42], [0.4, 1.5], [2.15, 1.5], [2.95, 1.0], [3.62, 0.92], [3.9, 0.8], [3.9, 0.34]],
  windscreen: 4,
  windows: [
    { u0: 0.42, u1: 1.02, v0: 1.0, v1: 1.36 },
    { u0: 1.1, u1: 1.62, v0: 1.0, v1: 1.36 },
    { u0: 1.7, u1: 2.2, v0: 1.0, v1: 1.36 },
  ],
  door: { u0: 1.1, u1: 1.62, v0: 0.45, v1: 1.4 },
  rearWindow: [0.62, 1.05],
  wheels: { rear: 0.78, front: 3.1, radius: 0.29 },
  roofRack: false,
};

/** Toyota Corolla-style saloon: private cars and taxis. */
export const SALOON: VehicleSpec = {
  id: 'saloon',
  length: 4.5,
  width: 1.78,
  height: 1.46,
  profile: [[0, 0.34], [0, 0.92], [0.3, 1.0], [0.95, 1.03], [1.4, 1.43], [2.95, 1.46], [3.5, 1.03], [4.38, 0.92], [4.5, 0.74], [4.5, 0.34]],
  windscreen: 5,
  windows: [
    { u0: 1.2, u1: 2.1, v0: 1.06, v1: 1.36 },
    { u0: 2.18, u1: 3.05, v0: 1.06, v1: 1.36 },
  ],
  rearWindow: [0.95, 1.0],
  wheels: { rear: 0.85, front: 3.55, radius: 0.31 },
};

/** Land Cruiser / RAV4-style SUV, everywhere in Cantonments. */
export const SUV: VehicleSpec = {
  id: 'suv',
  length: 4.8,
  width: 1.9,
  height: 1.85,
  profile: [[0, 0.42], [0, 1.75], [0.18, 1.85], [3.35, 1.85], [3.8, 1.3], [4.68, 1.16], [4.8, 0.9], [4.8, 0.42]],
  windscreen: 3,
  windows: [
    { u0: 0.2, u1: 1.05, v0: 1.3, v1: 1.72 },
    { u0: 1.12, u1: 2.2, v0: 1.3, v1: 1.72 },
    { u0: 2.28, u1: 3.3, v0: 1.3, v1: 1.72 },
  ],
  rearWindow: [1.25, 1.72],
  wheels: { rear: 0.95, front: 3.9, radius: 0.38 },
};

/** Kia-style box truck. */
export const BOX_TRUCK: VehicleSpec = {
  id: 'truck',
  length: 7.2,
  width: 2.3,
  height: 3.1,
  profile: [[0, 0.55], [0, 3.1], [5.3, 3.1], [5.3, 2.6], [6.75, 2.6], [7.12, 1.6], [7.2, 0.55]],
  windscreen: 4,
  windows: [{ u0: 5.95, u1: 6.65, v0: 1.75, v1: 2.4 }],
  rearWindow: [3.0, 3.0],
  wheels: { rear: 1.5, front: 6.2, radius: 0.46 },
};

/** Pragya: covered passenger tricycle. */
export const PRAGYA: VehicleSpec = {
  id: 'pragya',
  length: 2.7,
  width: 1.3,
  height: 1.8,
  profile: [[0, 0.3], [0, 1.72], [0.1, 1.8], [2.0, 1.8], [2.35, 1.25], [2.7, 0.9], [2.7, 0.3]],
  windscreen: 3,
  windows: [{ u0: 0.25, u1: 1.9, v0: 0.95, v1: 1.6 }],
  rearWindow: [1.0, 1.55],
  wheels: { rear: 0.55, front: 2.35, radius: 0.24 },
};
